import { Typography } from '@altibox/design-system-component-lib';
import { css, Interpolation, styled } from 'styled-components';

import { Image } from 'app/components/image';
import { colorBlue80, colorCommon80, colorCommonBlue80, colorPrimary100 } from 'app/style/colors';
import { spacing2 } from 'app/style/spacing';

import { AlertType } from './alert-type';

export interface StyledAlertProps {
    type: AlertType;
}

const ICON_HEIGHT = '20px';

const ALERT_TYPE_STYLES: Record<AlertType, Interpolation<object>> = {
    [AlertType.INFO]: css`
        border: 1px solid ${colorBlue80};
        background: ${colorCommonBlue80};
    `,
    [AlertType.ERROR]: css`
        border: 1px solid ${colorCommon80};
        background: ${colorPrimary100};
    `,
};

export const StyledAlert = styled.div<StyledAlertProps>`
    ${(props) => ALERT_TYPE_STYLES[props.type]}
    border-radius: 6px;
    padding: ${spacing2};
`;

export const StyledWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${spacing2};
`;

export const StyledIcon = styled(Image)`
    max-height: ${ICON_HEIGHT};
    margin-right: ${spacing2};
    align-self: center;
`;

export const StyledTitle = styled(Typography)`
    font-weight: bold;
`;
